import type { CatalogHostDto } from '../../data/types'
import { availablePercentageValues } from './hostLabels'
import { CAPABILITY_ROWS } from './CatalogCapabilities'

export function CatalogAvailability({ host }: { host: CatalogHostDto }) {
  const percentages = availablePercentageValues(host)

  return <div className="catalog-availability" aria-label="Available now">
    {CAPABILITY_ROWS.map(({ id, label, Icon }) => {
      const value = percentages[id]
      return <div key={id} className="catalog-availability-row" role="group" aria-label={label}>
        <Icon className="catalog-capability-icon" size={20} strokeWidth={1.8} aria-hidden="true" />
        <strong className="catalog-availability-amount" title={value === '—' ? 'Percentage not reported' : undefined}>{value}</strong>
      </div>
    })}
  </div>
}
